import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import DtoSelection from '../../../../referencial/components/parameter/dto/DtoSelection'
import { getDate } from '../../../../utils/DateUtil'
import CampaignPlanningDto from '../../../dto/CampaignPlanningDto'
import { NewTable } from 'components/datatable/NewTable'

const headers = ['startDate', 'endDate', 'nbStations', 'selection', 'nbParam']

const PlanningsPanel = ({
    plannings = [],
    selections = [],
    editMode = false,
    onDelete = () => { },
    onUpdate = () => { },
    onDuplicate = () => { },
}) => {
    const planningsFormated = plannings.map(({ startDate, endDate, stationsPlan, parametersPlan, selection }, index) => {
        const {
            name = '',
        } = selections.find(({ code }) => code === selection) || {}
        return {
            startDate: getDate(startDate),
            endDate: getDate(endDate),
            nbStations: `${stationsPlan.length}`,
            nbParam: `${parametersPlan.length}`,
            selection: name,
            index,
        }
    })

    const lineActions = [{
        icon: 'close',
        onClick: ({ index }) => onDelete(index),
        displayed: editMode,
    }, {
        icon: 'edit',
        onClick: ({ index }) => onUpdate(plannings[index], index),
        displayed: editMode,
    }, {
        icon: 'add_to_photos', // duplicate
        onClick: ({ index }) => onDuplicate(plannings[index]),
        displayed: editMode,
    }]

    return (
        <NewTable
            rows={planningsFormated}
            headers={headers}
            lineActions={lineActions}
        />
    )
}

PlanningsPanel.propTypes = {
    editMode: PropTypes.bool,
    plannings: PropTypes.arrayOf(PropTypes.instanceOf(CampaignPlanningDto)),
    selections: PropTypes.arrayOf(PropTypes.instanceOf(DtoSelection)),
    onDelete: PropTypes.func,
    onUpdate: PropTypes.func,
    onDuplicate: PropTypes.func,
}

const mapStateToProps = store => ({
    selections: store.ParameterReducer.selectionsWithParam,
})

export default connect(mapStateToProps)(PlanningsPanel)